// Shared contract for jumping to a specific employee input row. The employee
// table (DataInput) listens for FOCUS_EMPLOYEE_INPUT_EVENT, opens the editor,
// scrolls to the row, and focuses the field identified by `validationId`.
// Keep the id format in one place so warning links, calculated-results errors,
// and the table rows all agree.
export const FOCUS_EMPLOYEE_INPUT_EVENT = 'retira:focus-employee-input'

// Companion to the input event, for the calculated-results table on the Outputs
// pane. The employee here is identified by id (not row index) because the
// results table is keyed and sorted/filtered by id, not input position.
export const FOCUS_EMPLOYEE_OUTPUT_EVENT = 'retira:focus-employee-output'

export function employeeRowKey(employeeIndex) {
  return `employee-row-${employeeIndex}`
}

export function employeeFieldValidationId(employeeIndex, field) {
  return `${employeeRowKey(employeeIndex)}-${field}`
}

// Dispatch a request to reveal and focus an employee input. `field` defaults to
// the ID column, which is a stable anchor for "take me to this employee's row".
export function focusEmployeeInput({ employeeIndex, field = 'id' }) {
  if (typeof window === 'undefined' || !Number.isInteger(employeeIndex) || employeeIndex < 0) return
  window.dispatchEvent(new CustomEvent(FOCUS_EMPLOYEE_INPUT_EVENT, {
    detail: {
      kind: 'employee',
      validationId: employeeFieldValidationId(employeeIndex, field),
      employeeIndex,
      field,
    },
  }))
}

// Dispatch a request to reveal and highlight an employee's row in the Outputs
// results table. EmployeeDetails listens, pops out the results, clears filters,
// pages to the row, and flashes it.
export function focusEmployeeOutput({ employeeId }) {
  if (typeof window === 'undefined' || employeeId === null || employeeId === undefined || employeeId === '') return
  window.dispatchEvent(new CustomEvent(FOCUS_EMPLOYEE_OUTPUT_EVENT, {
    detail: { employeeId: String(employeeId) },
  }))
}
